import { Box } from '@mui/material'
import React from 'react'
import type { WhoAmIPermissions } from '../../../types'
import styles from './HeaderNavigation.module.scss'
import { DesktopNavigation, MobileNavigation } from './components'

interface HeaderNavigationProps {
  userPermissions: WhoAmIPermissions | null
}

const HeaderNavigation = ({ userPermissions }: HeaderNavigationProps) => (
  <header className={styles.header}>
    <div className={styles.HeaderNavigation}>
      <Box
        className={styles.DesktopNavigationBox}
        display={{ xs: 'none', sm: 'none', md: 'flex' }}
      >
        <DesktopNavigation userPermissions={userPermissions} />
      </Box>
      <Box
        className={styles.MobileNavigationBox}
        display={{ xs: 'flex', sm: 'flex', md: 'none' }}
      >
        <MobileNavigation userPermissions={userPermissions} />
      </Box>
    </div>
  </header>
)

export default HeaderNavigation
